export const FIELD_NAMES = {
  PASSWORD: 'password',
  EMAIL: 'email'
};

export const EMAIL_MAX_LENGTH = 254;
export const PASSWORD_MAX_LENGTH = 128;
export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_LENGTH_VALIDATION = 'password_length_validation';
export const PASSWORD_LOWERCASE_VALIDATION = 'password_lowercase_validation';
export const PASSWORD_NUMBER_VALIDATION = 'password_number_validation';
export const PASSWORD_SYMBOL_VALIDATION = 'password_symbol_validation';
export const PASSWORD_UPPERCASE_VALIDATION = 'password_uppercase_validation';

// TODO: Add message ids to use component name prefixes.
const messageKey = 'shopping.page.checkout.account.form.field.password.error.invalid';

export const ERROR_MESSAGE_IDS = {
  [PASSWORD_LENGTH_VALIDATION]: `${messageKey}.length`,
  [PASSWORD_LOWERCASE_VALIDATION]: `${messageKey}.lowercase`,
  [PASSWORD_NUMBER_VALIDATION]: `${messageKey}.number`,
  [PASSWORD_SYMBOL_VALIDATION]: `${messageKey}.symbol`,
  [PASSWORD_UPPERCASE_VALIDATION]: `${messageKey}.uppercase`
};

export const VALIDATIONS = [
  PASSWORD_LENGTH_VALIDATION,
  PASSWORD_UPPERCASE_VALIDATION,
  PASSWORD_LOWERCASE_VALIDATION,
  PASSWORD_NUMBER_VALIDATION,
  PASSWORD_SYMBOL_VALIDATION
];
